import React from 'react';
import { BookOpen, Award, Quote } from 'lucide-react';

const AboutPage = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">About the Book</h1>
            <p className="text-2xl opacity-90">The Lost Code Mystery - A Journey Through Secrets and History</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">The Story</h2>
            <div className="prose prose-lg">
              <p className="text-lg text-gray-700 mb-6">
                The Lost Code Mystery began as a fascination with cryptography and the hidden messages 
                that have shaped history. Victor Grösser, drawing on his background in technology and 
                his love for historical mysteries, crafted a story that weaves together past and present.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                The novel explores themes of truth, secrecy, and the lengths people will go to protect 
                what they believe in. Through the character of Dr. Elena Vasquez, readers experience the 
                thrill of discovery and the danger that comes with uncovering long-buried secrets.
              </p>
              <p className="text-lg text-gray-700 mb-8">
                Set against the backdrop of historic European cities and modern-day intrigue, The Lost 
                Code Mystery is both a tribute to classic thrillers and a fresh take on the genre.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
              <div className="bg-amber-50 p-8 rounded-xl">
                <h3 className="font-bold text-xl mb-4">Genre</h3>
                <p className="text-gray-700">Techno-thriller / Historical Mystery</p>
              </div>
              <div className="bg-amber-50 p-8 rounded-xl">
                <h3 className="font-bold text-xl mb-4">Length</h3>
                <p className="text-gray-700">384 pages / 95,000 words</p>
              </div>
              <div className="bg-amber-50 p-8 rounded-xl">
                <h3 className="font-bold text-xl mb-4">Publication</h3>
                <p className="text-gray-700">March 2026</p>
              </div>
              <div className="bg-amber-50 p-8 rounded-xl">
                <h3 className="font-bold text-xl mb-4">ISBN</h3>
                <p className="text-gray-700">978-3-16-148423-4</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;